/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */


import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./src/styles/global.css";

import React from "react";
import { AuthProvider } from "./invoice-generator/src/components/AuthProvider";
import { LanguageProvider } from "./invoice-generator/src/host/LanguageProvider";

const INVOICE_PREFIX = "/tools/general/invoice-generator";

export const wrapPageElement = ({
  element,
  props,
}: {
  element: React.ReactNode;
  props: { location: { pathname: string } };
}) => {
  if (!props.location.pathname.startsWith(INVOICE_PREFIX)) {
    return element;
  }
  return (
    <LanguageProvider>
      <AuthProvider>{element}</AuthProvider>
    </LanguageProvider>
  );
};

